import { getDataSourceColor } from 'models/DataSource/helpers';
import { EngineConfig } from './types';
import i18n from '@sprinklr/display-builder/i18n';

export const engineConfigs: EngineConfig[] = [
    {
        id: 'PAID',
        label: i18n.t('Paid'),
        icon: 'datasrc-paid',
        color: getDataSourceColor('paid'),
        report: 'DAILY_AD_STAT',
    },
    {
        id: 'ADVOCACY',
        label: i18n.t('Advocacy'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'ADVOCACY_ACTIVITY',
    },
    {
        id: 'BENCHMARKING',
        label: i18n.t('Benchmarking Insights'),
        icon: 'datasrc-sprinksights',
        color: getDataSourceColor('sprinksights'),
        report: 'POST_STATS_LIFETIME',
    },
    {
        id: 'CAMPAIGN',
        label: i18n.t('Content Marketing'),
        icon: 'datasrc-content-marketing',
        color: getDataSourceColor('content-marketing'),
    },
    {
        id: 'MONITORING_DASHBOARD',
        label: i18n.t('Engagement Dashboard'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
    },
    {
        id: 'LISTENING',
        label: i18n.t('Listening Insights'),
        icon: 'datasrc-sprinksights',
        color: getDataSourceColor('sprinksights'),
        report: 'SPRINKSIGHTS',
    },
    {
        id: 'RDB_FIREHOSE',
        label: i18n.t('Listening Explorer'),
        icon: 'datasrc-sprinksights',
        color: getDataSourceColor('sprinksights'),
        report: 'RDB_FIREHOSE',
    },
    {
        id: 'INBOUND_MESSAGE',
        label: i18n.t('Reporting Insights: Inbound Analytics'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'INBOUND_MESSAGE',
    },
    {
        id: 'PLATFORM',
        label: i18n.t('Reporting Insights: Social Analytics'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'POST_INSIGHTS',
    },
    {
        id: 'TRENDING_EVENT',
        label: i18n.t('Smart Trends'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('sprinksights'),
    },
    {
        id: 'STORY_MESSAGE',
        label: i18n.t('Story Analytics'),
        icon: 'datasrc-sprinksights',
        color: getDataSourceColor('sprinksights'),
        report: 'STORY_MESSAGE',
    },
    {
        id: 'HISTORIC_TRENDS',
        label: i18n.t('X Trends'),
        icon: 'twitter',
        color: getDataSourceColor('twitter'),
        report: 'HISTORIC_TRENDS',
    },
    {
        id: 'UNIFIED_ANALYTICS_REPORTING_ENGINE',
        label: i18n.t('Unified Analytics'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
    },
    {
        id: 'UNIVERSAL_PROFILE',
        label: i18n.t('Universal Profile'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'UNIVERSAL_PROFILE',
    },
    {
        id: 'SPR_TASK',
        label: i18n.t('Task'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'SPR_TASK',
    },
    {
        id: 'CUSTOM_ENTITY',
        label: i18n.t('Custom Entity'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
    },
    {
        id: 'VOICE',
        label: i18n.t('Voice Analytics'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'VOICE_AGENT_PERFORMANCE',
    },
    {
        id: 'COMMUNITY',
        label: i18n.t('Community'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'COMMUNITY_USER_ACTIVITY',
    },
    {
        id: 'SAM',
        label: i18n.t('DAM'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'SOCIAL_MEDIA_ASSET',
    },
    {
        id: 'AUDIENCE_ACTIVITY',
        label: i18n.t('Audience Activity'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'AUDIENCE_ACTIVITY',
    },
    {
        id: 'OUTBOUND_MESSAGE',
        label: i18n.t('Outbound Message'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'OUTBOUND_MESSAGE',
    },
    {
        id: 'CONSUMPTION',
        label: i18n.t('Consumption Analytics'),
        icon: 'datasrc-reporting',
        color: getDataSourceColor('reporting'),
        report: 'CONSUMPTION_ACTIVITY',
    },
];

export const rapidPublishAllowedEngines = [
    'PLATFORM',
    'INBOUND_MESSAGE',
    'UNIVERSAL_PROFILE',
    'VOICE',
    'SPR_TASK',
    'CUSTOM_ENTITY',
    'COMMUNITY',
    'SAM',
    'AUDIENCE_ACTIVITY',
    'OUTBOUND_MESSAGE',
    'CONSUMPTION',
];
